var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrap"},[_c('div',{staticClass:"loading"},[_c('img',{staticClass:"loading-icon",attrs:{"src":require("@img/icon_loading_2.png"),"alt":_vm.loadingAlt}})])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }